import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.css';
import './css/85bb65.css';
import API from './API';
import { R } from './routes';

import store from './store';
import Me from './Me';
import { Provider as ReduxProvider } from 'react-redux';
import { init } from "@sentry/react";
import { TraksProvider, TraksConsumer } from './traks.js';
import PotentialFatalErrorPage from './p/PotentialFatalErrorPage';
import { TickerTapeInjectCSS } from './c/TickerTape';

init({
  dsn: "https://40f5c9f36f2ee9010522f385c6400a52@o1289867.ingest.us.sentry.io/4510119002112000",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

/* not-too-pretty solution for making the current language globally available.
 * the alternative would be to somehow support via non-React stuff in traks?
 * but yeah, this non-Component solves the problem :) */
const SetLangGlobal = (props) => {
	window.GLOBAL_LANG = props.lang;
	return null;
};

/* ...the browser inside iOS app lacks console.warn? */
if (console.warn === undefined) console.warn = console.log;

const start = () => {
	TickerTapeInjectCSS();
	API.get("/a/whoami", (me) => {
		Me.set(me);
		ReactDOM.render(
			<ReduxProvider store={store}>
				<TraksProvider>
					<TraksConsumer><SetLangGlobal/></TraksConsumer>
					<PotentialFatalErrorPage>
						{R.component()}
					</PotentialFatalErrorPage>
				</TraksProvider>
			</ReduxProvider>,
			document.getElementById('root')
		);
	});
};
if (IS_AKTIEDYSTEN_DK) {
	import('./css/aktiedysten_dk.css').then(start);
} else if (IS_AKTIEKAMPEN_SE) {
	import('./css/aktiekampen_se.css').then(start);
} else if (IS_INVESTSPIEL_DE) {
	import('./css/investspiel_de.css').then(start);
} else if (IS_TRADERR_COM) {
	import('./css/traderr_com.css').then(start);
}



// WEBPACK FOOTER //
// ./src/index.js